// Botón "Volver" / "Tornar" / "Back" que sustituye su acción por
// window.close() cuando la página vive dentro de un popup. Detección via
// window.opener (signal browser-side estándar; Keycloak no expone el
// display=popup OIDC al FTL/JS por defecto). Sin esta sustitución, navegar
// a clientBaseUrl o ejecutar history.back() carga la app dentro de la
// propia ventana popup y deja al usuario atrapado en una ventana de tamaño
// popup. Usado en ErrorPage, InfoPage, LogoutConfirmPage y
// LoginPageExpiredPage (cualquier pantalla que ofrezca volver al cliente).

import { msg } from "../i18n";

export interface PopupAwareBackButtonProps {
  // URL de destino cuando NO estamos en popup. Si se da, el botón es un
  // <a href={href}>.
  href?: string;
  // Acción cuando NO estamos en popup, alternativa a href. Útil para
  // history.back() en LogoutConfirm.
  onClick?: () => void;
}

export function PopupAwareBackButton({ href, onClick }: PopupAwareBackButtonProps) {
  const isPopup =
    typeof window !== "undefined" &&
    window.opener != null &&
    !window.opener.closed;

  if (isPopup) {
    return (
      <button
        id="backToApplication"
        type="button"
        onClick={() => window.close()}
        className="btn btn-lg btn-block btn-primary"
      >
        {msg("closeWindow")}
      </button>
    );
  }

  if (href) {
    return (
      <a
        id="backToApplication"
        href={href}
        role="button"
        className="btn btn-lg btn-block btn-primary"
      >
        {msg("backToApplication")}
      </a>
    );
  }

  return (
    <a
      id="backToApplication"
      onClick={onClick}
      role="button"
      className="btn btn-lg btn-block btn-primary"
    >
      {msg("backToApplication")}
    </a>
  );
}
